import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { AppState } from '../app';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';

export interface ChannelIdentitiesState {
  channelIdentities: ChannelIdentityViewModel[];
}

// initial state
export const channelIdentitiesState: ChannelIdentitiesState = {
  channelIdentities: [],
};

export const channelIdentities: Module<ChannelIdentitiesState, AppState> = {
  namespaced: false,
  state: channelIdentitiesState,
  actions,
  mutations,
  getters,
};
